import Masthead from '../Components/Masthead';
import SignIn from '../Components/SignInCard';
import SignUp from '../Components/SignUpCard';
import handleUpdateCharacterCreatorState from '../Components/handleUpdateCharacterCreatorState';
import './CharacterCreationPage.css'
import handleSaveImage from "../Components/handleSaveImage";
import handleGenerateCharacterImage from "../Components/handleGenerateCharacterImage";
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import handleNavigation from '../Components/handleNavigate';
import ForgotPasswordCard from '../Components/ForgotPasswordCard';
import PurchaseTokensCard from '../Components/PurchaseTokensCard';
import useInactivityTimeout from "../Utilities/useInactivityTimeout"
import {Button, Modal} from '@nxtvid/component-library';
import { CharacterContext } from '../Contexts/CharacterContext';
import { SignUpInfoContext } from '../Contexts/SignUpInfoContext';
import { CharacterCreatorStateContext } from '../Contexts/CharacterCreatorStateContext';
import { AuthContext } from '../Contexts/AuthContext';
import { UserContext } from '../Contexts/UserContext';
import { IsDisabledContext } from '../Contexts/IsDisabledContext';
import { MastheadRefContext } from '../Contexts/MastheadRefContext';

const CharacterCreationPage = () => {
  const {isAuthenticated, setIsAuthenticated} = useContext(AuthContext)
  const {userInfo, setUserInfo} = useContext(UserContext)
  const {signUpInfo, setSignUpInfo} = useContext(SignUpInfoContext)
  const {characters, setCharacters} = useContext(CharacterContext)
  const {isDisabled, setIsDisabled} = useContext(IsDisabledContext)
  const {characterCreatorState, setCharacterCreatorState} = useContext(CharacterCreatorStateContext)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [isToggled, setIsToggled] = useState(false)
  const tokenIcon = require('../Images/TokensIcon.png')
  const navigate = useNavigate();
  const {mastheadRef} = useContext(MastheadRefContext)
  useInactivityTimeout(21600000, 'cooppStoryboardGenerator_AuthToken');


   // Modal States
      const [isModalOpen, setIsModalOpen] = useState(false)
      const [modalType, setModalType] = useState('confirm')
      const [modalSize, setModalSize] = useState('medium')
      const [modalTitle, setModalTitle] = useState('')
      const [modalDescription, setModalDescription] = useState('' )
      const [modalOnConfirm, setModalOnConfirm] = useState(() => () => {})
      const [modalOnCancel, setModalOnCancel] = useState(() => () => {})
      const [modalConfirmButtonText, setModalConfirmButtonText] = useState('')
      const [modalCancelButtonText, setModalCancelButtonText] = useState('')

  const handleResize = () =>{
      setWindowWidth(window.innerWidth)
    }
  
    useEffect(()=>{
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);  // Clean up the event listener
      };
    }, [])
    
    useEffect(() => { 
            if (isAuthenticated === null) return; 
        
            if (userInfo.isVideographer === null) {
              window.location.href = '/';
            }
          }, [userInfo]);

  const handleToggle = () =>{
    const tempIsToggled = !isToggled
    setIsToggled(!isToggled)
    if(tempIsToggled){
      document.getElementsByClassName('Character-Creator-Output-Section')[0].style.display = 'block'
      document.getElementsByClassName('Character-Creator-Input-Section')[0].style.display = 'none'
    }
    else{
      document.getElementsByClassName('Character-Creator-Output-Section')[0].style.display = 'none'
      document.getElementsByClassName('Character-Creator-Input-Section')[0].style.display = 'block'
    }
  }

   

  const GenerateCharacterImageButton = ({characterCreatorState, setCharacterCreatorState, userInfo}) =>{
    return(
            <div className='Button-Container-CharacterCreation'> 
              <Button label='Generate Image' disabled={isDisabled} id='generateCharacterImageButton' className='generateCharacterImageButton' onClick={()=> {handleToggle(); handleGenerateCharacterImage({characterCreatorState:characterCreatorState, setCharacterCreatorState:setCharacterCreatorState, userInfo:userInfo, setIsDisabled:setIsDisabled, mastheadRef: mastheadRef})}}/>
                <div className='Token-Container-Character-Creation'>
                  <img alt='Tokens Icon' className='Tokens-Icon' src={tokenIcon}/>
                  <p className='Tokens-Amount'>~ 1</p>
                </div>
            </div>
           
    )
}


  const handleConfirmLeavePage = () =>{
    setIsModalOpen(true)
    setModalTitle("Back to Storyboard")
    setModalDescription("Are you sure you want to leave this page? Your work won't automatically be saved.")
    setModalType("confirm")
    setModalSize("medium")
    setModalOnConfirm(() => () => {
      setIsModalOpen(false);
      handleNavigation({path: "/Storyboard", navigate});
    });
    setModalOnCancel(() => () => {
      setIsModalOpen(false);
    });
    setModalConfirmButtonText("Go to Storyboard")
    setModalCancelButtonText("Cancel")
  }

  const handleSaveCharacter = () => {
    handleSaveImage({setCharacters: setCharacters, characters:characters, characterCreatorState:characterCreatorState, setCharacterCreatorState:setCharacterCreatorState}); 
    setIsModalOpen(true);
    setModalTitle("Character Saved")
    setModalDescription("Your character has been saved successfully!")
    setModalType("alert")
    setModalSize("medium")
    setModalOnConfirm(() => () => {
      setIsModalOpen(false);
    });
    setModalOnCancel(() => () => {
      setIsModalOpen(false);
    });
    setModalConfirmButtonText("OK")
  }
  
  
  return (
      <div className="App">
        {isModalOpen ? <Modal size={modalSize} type={modalType} title={modalTitle} description={modalDescription} onConfirm={modalOnConfirm} onClose={modalOnCancel} confirm_button_text={modalConfirmButtonText} cancel_button_text={modalCancelButtonText}/> : <p></p>}
      <div className="character-creator-body">
          <div className="background-shades" onClick={(e)=>{e.target.style.display='none'; document.getElementsByClassName("sign-in-card")[0].style.display='none'; document.getElementsByClassName("sign-up-card")[0].style.display='none'; document.getElementsByClassName("forgot-password-card")[0].style.display='none';document.getElementsByClassName("purchase-tokens-card")[0].style.display='none'; document.getElementsByClassName('sign-in-notification-message')[0].innerHTML=''; document.getElementsByClassName('sign-up-notification-message')[0].innerHTML=''; }}/>
        <div className = 'character-creation-header'>
        <Button type='primary' label={windowWidth > 425 ? 'Back to Storyboard' : 'Back'} className='backToDashboardButton'  onClick={()=>handleConfirmLeavePage()}/>
        <Button type = 'primary' label= {windowWidth > 425 ? 'Save Character' : 'Save'} className='saveCharacterButton'  onClick={handleSaveCharacter}/>
        </div>
        <div className="Character-Creator">
            <div className="Character-Creator-Input-Section">
            <h2 className='Character-Creator-Header'>Character Creator</h2>
              <div className="Character-Creator-Input-Section-Div">
                <div className="Character-Name-Input">
                  <label htmlFor="characterNameInput">Character Name</label>
                  <input type="text" className='characterInput' placeholder='e.g., Harold' id="characterNameInput" value={characterCreatorState.name} onChange={(e)=>handleUpdateCharacterCreatorState('name', e.target.value, characterCreatorState, setCharacterCreatorState)}/>
                </div>
                <div className="Character-Age-Gender-Ethnicity-Input">
                  <div className="Character-Age-Input">
                    <label htmlFor="characterAgeInput">Age</label>
                    <input type="text" className='characterInput' placeholder='e.g., 35' id="characterAgeInput" value={characterCreatorState.age} onChange={(e)=>handleUpdateCharacterCreatorState('age', e.target.value, characterCreatorState, setCharacterCreatorState)} />
                  </div>
                  <div className="Character-Gender-Input">
                    <label htmlFor="characterGenderInput">Gender</label>
                    <input type="text" className='characterInput' placeholder='e.g., Female' id="characterGenderInput" value={characterCreatorState.gender} onChange={(e)=>handleUpdateCharacterCreatorState('gender', e.target.value, characterCreatorState, setCharacterCreatorState)}  />
                  </div>
                  <div className="Character-Ethnicity-Input">
                    <label htmlFor="characterEthnicityInput">Ethnicity</label>
                    <input type="text" className='characterInput' placeholder='e.g., Filipino' id="characterEthnicityInput" value={characterCreatorState.ethnicity} onChange={(e)=>handleUpdateCharacterCreatorState('ethnicity', e.target.value, characterCreatorState, setCharacterCreatorState)}  />
                  </div>
                </div>
                <div className="Character-Hair-Input">
                  <label htmlFor="characterHairInput">Hair</label>
                  <input type="text" className='characterInput' placeholder='e.g., shoulder-length, purple' id="characterHairInput" value={characterCreatorState.hair} onChange={(e)=>handleUpdateCharacterCreatorState('hair', e.target.value, characterCreatorState, setCharacterCreatorState)} />
                </div>
                <div className="Character-Clothing-Input">
                  <label htmlFor="characterClothingInput">Clothing</label>
                  <textarea rows="4" type="text" className='characterInput' placeholder='e.g., faux-leather jacket and swim trunks' id="characterClothingInput" value={characterCreatorState.clothing} onChange={(e)=>handleUpdateCharacterCreatorState('clothing', e.target.value, characterCreatorState, setCharacterCreatorState)} />
                </div>
                <div className="Character-Negative-Input">
                  <label htmlFor="characterNegativeInput">Features to Avoid</label>
                  <textarea rows="4" type="text" className='characterInput' placeholder='e.g., wrinkles, beard' id="characterNegativeInput" value={characterCreatorState.featuresToAvoid} onChange={(e)=>handleUpdateCharacterCreatorState('featuresToAvoid', e.target.value, characterCreatorState, setCharacterCreatorState)} />
                </div>
                
                <GenerateCharacterImageButton characterCreatorState = {characterCreatorState} setCharacterCreatorState={setCharacterCreatorState} userInfo={userInfo} />
                
              </div>
            </div>
            <div className="Character-Creator-Output-Section">
              <img
                id="characterCreatorOutputPreview"
                className="Character-Creator-Output-Preview"
                src={characterCreatorState.characterPreview}
                alt="Character Preview"
              />
            </div>
            <div className='toggle-component-container'>
            <p className='creator-label'>Creator</p>
            <div className={`toggle-container ${isToggled ? 'toggled' : ''}`} id='toggle-container' onClick={handleToggle}>
              <div className='toggle-button'/> 
            </div>
            <p className='preview-label'>Preview</p>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default CharacterCreationPage;
  